import { FormEnums } from "app/services/api/types/forms/enums/FormEnums";
import { AssessmentSingleEntryTemplate } from "app/features/reporting/templates/AssessmentSingleEntryTemplate";
import { useResidentContext } from "app/features/residents/provider/ResidentProvider";

const tag = FormEnums.RESIDENT_PORTFOLIO;

export default function ResidentDigitalPortfolioForm() {
  const { resident } = useResidentContext();
  return (
    <AssessmentSingleEntryTemplate
      tag={tag}
      noEntryTitle="Digital Portfolio not yet created"
      fillLink={`/residents/${resident?.id}/portfolio/fill`}
      versioned
    />
  );
}
